import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { List } from 'foundations-components/transitional/components/List';
import { SanitizedHtmlText } from '../../SanitizedHtmlText';
import { FeatureDisplayChecklistItem } from './FeatureDisplayChecklistItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultFeatureName = ({
  featureDisplayName,
  isBeta
}) => /*#__PURE__*/_jsxs(Flex, {
  as: "span",
  display: "inline-flex",
  alignItems: "center",
  gap: "100",
  flexWrap: "wrap",
  children: [/*#__PURE__*/_jsx(Text, {
    as: "span",
    children: featureDisplayName
  }), isBeta && /*#__PURE__*/_jsx(FormattedMessage, {
    message: "feature-monetization.featureTable.beta"
  })]
});
export const PriorityFeatures = ({
  features,
  renderFeatureName
}) => {
  return /*#__PURE__*/_jsx(List, {
    children: features.map((feature, index) => {
      const secondaryMessage = feature.shortName === 'payments' ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.priorityFeatures.usOnly"
      }) : null;
      const featureNameNode = renderFeatureName ? renderFeatureName(feature) : /*#__PURE__*/_jsx(DefaultFeatureName, {
        featureDisplayName: feature.displayName,
        isBeta: feature.isBeta
      });
      return /*#__PURE__*/_jsx(Flex, {
        marginBlockStart: index > 0 ? '100' : undefined,
        children: /*#__PURE__*/_jsx(FeatureDisplayChecklistItem, {
          tooltipMessage: /*#__PURE__*/_jsx(SanitizedHtmlText, {
            body: feature.description
          }),
          message: featureNameNode,
          secondaryMessage: secondaryMessage,
          isAvailable: feature.isAvailable
        })
      }, feature.shortName);
    })
  });
};